import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {Consultations411Content} from "../components/contentComponents/Consultations411Content.jsx";

export function Consultations411() {
    return (
        <div>
            <Header></Header>
            <Consultations411Content></Consultations411Content>
            <Footer></Footer>
        </div>
    )
}
